import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Level1 from './pages/level1';
import Level2 from './pages/level2';
import Level3 from './pages/level3';
import StartPage from './pages/start-page';
import EndPage from './pages/end-page';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<StartPage />} />
          <Route path="/end" element={<EndPage />} />
        <Route path="/level1" element={<Level1 />} />
        <Route path="/level2" element={<Level2 />} />
          <Route path="/level3" element={<Level3 />} />
      </Routes>
    </Router>
  );
}

export default App;
